import React, { useEffect } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import shipping from "../image/shipping.webp";

const Shipping = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="mx-auto max-w-[600px] p-20 text-[14px] leading-10">
        <p className="mb-8 text-center text-[30px] uppercase text-btn">
          Shipping policy
        </p>
        <p>
          Our shipping team hours are 8am-5pm MST Monday-Friday. If you order on
          Friday, your package won't go out until the following Monday.
          Fulfillment typically takes between 2-3 days. Delivery time will
          depend on the shipping option you chose. Standard shipping usually
          takes 2-10 business days (but might change for the holiday season).
        </p>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default Shipping;
